'use client';

import iconCoinSmall from '@/assets/images/icons/coin-small.png';
import iconCard from '@/assets/images/menu/icon-card.png';
import iconCoin from '@/assets/images/menu/icon-coin.png';
import iconEdit from '@/assets/images/menu/icon-edit.png';
import iconHistory from '@/assets/images/menu/icon-history.png';
import iconLogin from '@/assets/images/menu/icon-login.png';
import iconLogout from '@/assets/images/menu/icon-logout.png';
import iconMailBox from '@/assets/images/menu/icon-mailbox.png';
// import iconNotReceived from '@/assets/images/menu/icon-not-received.png';
import iconPresent from '@/assets/images/menu/icon-present.png';
import iconQr from '@/assets/images/menu/icon-qr.png';
import iconQuestion from '@/assets/images/menu/icon-question.png';
import iconSerial from '@/assets/images/menu/icon-serial.png';
import iconSetting from '@/assets/images/menu/icon-setting.png';
import iconShipping from '@/assets/images/menu/icon-shipping.png';
import iconWChance from '@/assets/images/menu/icon-wchance.png';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { formatCurrency } from '@/utils/formatters';
import { goMainOneTimeAuth } from '@/utils/functions';
import { atom, useAtom } from 'jotai';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import IconTextUnit from '../../ui/IconTextUnit/IconTextUnit';
import LinkListItem from '../../ui/LinkListItem/LinkListItem';
import styles from './CommonMenu.module.scss';

import iconUsers from '@/assets/images/menu/icon-users.png';

// メニュー開閉
// NOTE: 共通処理に移動したい
const isMenuOpenedAtom = atom(false);
const useIsMenuOpenedAtom = () => useAtom(isMenuOpenedAtom);

export { useIsMenuOpenedAtom };

// コンポーネント
function CommonMenu({
  isOptionNotEntered = false,
  hasPendingEntry = false,
  onLogout,
  onSerialCode,
  userUnreadMessageBoxCount = 0,
  userName,
}: {
  isOptionNotEntered?: boolean;
  hasPendingEntry?: boolean;
  hasAlertEcItem?: boolean;
  onLogout: () => void;
  onSerialCode: () => void;
  userUnreadMessageBoxCount?: number;
  userCoin?: number;
  userName?: string;
}) {
  const router = useRouter();
  const [isMenuOpenedValue, setIsMenuOpened] = useIsMenuOpenedAtom();
  const nodeRef = useRef(null);

  return (
    <CSSTransition in={isMenuOpenedValue} timeout={200} classNames={styles} nodeRef={nodeRef} appear unmountOnExit>
      <div
        className={`${styles.componentStyle}`}
        onClick={() => {
          setIsMenuOpened(false);
        }}
        ref={nodeRef}
      >
        <div className={styles.container}>
          <section className={styles.profile}>
            <div className={styles.profileDetail}>
              <Link href={'/account/edit'} className={styles.profileName}>
                <span className={utilsStyles.textEllipsis}>{userName}</span>
                &nbsp;
                <img src={iconEdit.src} alt='Edit' className={utilsStyles.textIconSmall} />
              </Link>
            </div>
          </section>
          <hr className={styles.hr} />
          <ul className={styles.menuList}>
            <li>
              <LinkListItem
                iconSrc={iconMailBox.src}
                onClick={() => {
                  router.push('/account/messages');
                }}
                text='メッセージボックス'
                showBadge={userUnreadMessageBoxCount > 0}
              />
            </li>
            <li>
              <LinkListItem
                iconSrc={iconPresent.src}
                onClick={() => {
                  router.push('/account/collection');
                }}
                text='オンラインくじ獲得景品一覧'
                showBadge={isOptionNotEntered}
              />
            </li>
            {/* <li>
                <LinkListItem
                  iconSrc={iconNotReceived.src}
                  onClick={() => {
                    router.push('/account/collection/hand-over');
                  }}
                  text='未受け取り景品一覧'
                />
              </li> */}
            <li>
              <LinkListItem
                iconSrc={iconWChance.src}
                onClick={() => {
                  router.push('/account/wchance-collection');
                }}
                text='Wチャンス賞チャレンジ履歴'
                showBadge={hasPendingEntry}
              />
            </li>
            <li>
              <LinkListItem
                iconSrc={iconCard.src}
                onClick={() => {
                  router.push('/account/credit-card');
                }}
                text='お支払い方法'
              />
            </li>
            <li>
              <LinkListItem iconSrc={iconSerial.src} onClick={onSerialCode} text='シリアルコードの入力' />
            </li>
            <li>
              <LinkListItem
                iconSrc={iconHistory.src}
                onClick={() => {
                  router.push('/account/payment/history');
                }}
                text='決済履歴'
              />
            </li>
            <li>
              <LinkListItem
                iconSrc={iconShipping.src}
                onClick={() => {
                  router.push(`/account/address?callback=${location.href}`);
                }}
                text='配送先の確認と変更'
              />
            </li>
            <li>
              <LinkListItem
                iconSrc={iconLogin.src}
                onClick={() => {
                  router.push('/account/change-email');
                }}
                text='メールアドレス設定'
              />
            </li>
            <li>
              <LinkListItem
                iconSrc={iconSetting.src}
                onClick={() => {
                  router.push('/account/notification');
                }}
                text='通知設定'
              />
            </li>
            <li>
              <LinkListItem
                iconSrc={iconQuestion.src}
                onClick={() => {
                  router.push('/faq');
                }}
                text='よくある質問'
              />
            </li>
            {process.env.NEXT_PUBLIC_ENV !== 'production' && (
              <li>
                <LinkListItem
                  iconSrc={iconQr.src}
                  onClick={() => {
                    router.push('/account/qr');
                  }}
                  text='現地受け取りQRコード'
                />
              </li>
            )}
            <li>
              <LinkListItem iconSrc={iconLogout.src} onClick={onLogout} text='ログアウト' />
            </li>
          </ul>
        </div>
      </div>
    </CSSTransition>
  );
}

export default CommonMenu;
